import uuid from 'uuid';

type Props = {
  sectionId: string;
};

export const createCarousel = (props: Props): { sectionId: string; id: string } => ({
  sectionId: props.sectionId,
  id: uuid(),
});
